export const isLogin = () => {
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType'); 
    
    if (!token) {
      throw new Error('unauthorized');
    }
    
    return { token, userType };
  };